import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@loader/ui';
import { Loader2 } from 'lucide-react';

interface PostApiDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  loading: boolean;
  onSubmit: (data: {
    name: string;
    config: { sync_mode?: 'append' | 'replace'; auto_tag_rotation?: boolean };
  }) => void;
}

export function PostApiDialog({ open, onOpenChange, loading, onSubmit }: PostApiDialogProps) {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      name: name || 'POST API Data',
      config: { sync_mode: 'append', auto_tag_rotation: true },
    });
  };

  const reset = () => {
    setName('');
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) reset();
        onOpenChange(o);
      }}
    >
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>POST API Connector</DialogTitle>
            <DialogDescription>
              Create a table that receives data via HTTP POST requests.
              After creation you'll get an endpoint URL and API key to start pushing data.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4 grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="post-api-name">Table Name</Label>
              <Input
                id="post-api-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Webhook Events"
              />
            </div>
          </div>

          <DialogFooter className="mt-6">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Create Table
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
